// src/App.js
import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "./config";
import LandingScreen from "./components/LandingScreen";
import ConsultationFormScreen from "./components/ConsultationFormScreen";
import ChatApp from "./components/ChatApp";
import AdminPanel from "./components/AdminPanel";
import SignInPage from "./components/SignInPage";
import SignUpPage from "./components/SignupPage";
import TermsAndConditions from "./components/terms _condition";
import PrivacyPolicy from "./components/privacy";

import "./App.css";

function App() {
  const [userId, setUserId] = useState(localStorage.getItem("user_id") || null);
  const [credits, setCredits] = useState(0);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [freeResponsesLeft, setFreeResponsesLeft] = useState(3);

  const handleLogout = () => {
    localStorage.clear();
    setUserId(null);
    setUserName("");
    setUserEmail("");
    setCredits(0);
    setFreeResponsesLeft(3);
    setIsLocked(false);
    setShowOptions(false);
    alert("Logged out successfully!");
    window.location.href = "/"; // Redirect to landing page
  };

  const fetchCredits = async (userId) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/get-credits/${userId}`);
      setCredits(res.data.credits);
      return res.data.credits;
    } catch (err) {
      console.error("❌ Credit fetch error:", err);
      return 0;
    }
  };

  const addBotMessage = (msg) => {
    console.log("🤖 BOT:", msg);
  };

  // 🔄 Add rename chat function
  const handleRenameChat = async (chatId, newName) => {
    try {
      await axios.put(`${API_BASE_URL}/rename-chat/${chatId}`, {
        new_name: newName,
      });
      console.log("✅ Chat renamed successfully");
    } catch (error) {
      console.error("❌ Failed to rename chat:", error);
    }
  };

  // ❌ Add delete chat function
  const handleDeleteChat = async (chatId) => {
    try {
      await axios.delete(`${API_BASE_URL}/delete-chat/${chatId}`);
      console.log("🗑️ Chat deleted successfully");
    } catch (error) {
      console.error("❌ Failed to delete chat:", error);
    }
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <LandingScreen
            setUserId={setUserId}
            setCredits={setCredits}
            setUserName={setUserName}
            setUserEmail={setUserEmail}
          />
        }
      />
      <Route
        path="/form"
        element={
          <ConsultationFormScreen
            setUserId={setUserId}
            fetchCredits={fetchCredits}
            addBotMessage={addBotMessage}
            setShowOptions={setShowOptions}
            setIsLocked={setIsLocked}
          />
        }
      />
      <Route
        path="/chat"
        element={
          <ChatApp
            userId={userId}
            fetchCredits={fetchCredits}
            setIsLocked={setIsLocked}
            setShowOptions={setShowOptions}
            isLocked={isLocked}
            freeResponsesLeft={freeResponsesLeft}
            setFreeResponsesLeft={setFreeResponsesLeft}
            handleLogout={handleLogout}
            onRenameChat={handleRenameChat}
            onDeleteChat={handleDeleteChat}
          />
        }
      />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/admin" element={<AdminPanel />} />
    </Routes>
    // ...
  );
}

export default App;